/**
 * @file
 * Remove search filter.
 *
 */
(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.removeSearchFilter = {
    attach(context, settings) {
      $(".remove-filter").click(function () {
        const datafield = $(this).attr("data-field");
        const buttonSelector =
          drupalSettings.remove_search_filter.button_selector;

        //Toggle classes when pill is visible
        if ($(window).width() < 768) {
          //Filter pill
          $(".filter-header").remove();
          $(".form-row").toggleClass("full-width show-filter");
          $(".remove-fullscreen-filter").toggleClass("show-close-button");
          $("body").toggleClass("stop-scroll");
          $("details").toggleClass("full-screen-form");
          $("button.form-submit").toggleClass("full-screen-submit");
          $("div.details-wrapper").toggleClass("full-screen-filter-sizing");
          $("summary").toggleClass("mobile-filter-font");
        }

        if (datafield === "edit-keyword") {
          $(`#${datafield}`).val("");
        } else if (datafield.indexOf("edit-field-target") > -1) {
          $(`input[data-drupal-selector^="${datafield}"]`).prop(
            "checked",
            false
          );
          $('input[data-drupal-selector^="edit-field-target-all"]').prop(
            "checked",
            true
          );
        } else if (datafield.indexOf("edit-field-course-delivery") > -1) {
          $(`input[data-drupal-selector^="${datafield}"]`).prop(
            "checked",
            false
          );
          $(
            'input[data-drupal-selector^="edit-field-course-delivery-all"]'
          ).prop("checked", true);
        } else {
          $(`input[data-drupal-selector="${datafield}"]`).removeAttr("checked");
        }

        $(`button[data-drupal-selector^="${buttonSelector}"]`).trigger("click");
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
